module.exports = __webpack_public_path__ + "static/media/garnetdp.77a64837.jpg";